import { useCallback, useRef, useEffect } from 'react';
import * as React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import { TextInput, Text, tokens } from '@hotjar/hotsauce';

const getInputCss = (inputWidth: number) => css`
  box-sizing: border-box;
  max-width: ${inputWidth}px;
`;

interface Props {
  name: string;
  onChange: (newName: string) => void;
  inputWidth: number;
  errorMessage: string | null;
}

export const SegmentName = ({ name, onChange, inputWidth, errorMessage }: Props): JSX.Element => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );
  const inputId = 'segment-name';

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <Text
        textType="subtitle2"
        css={css`
          display: inline-block;
          margin-bottom: ${tokens.spacer.x1};
        `}
      >
        {t('common:recordings.segment-edit-create.name.label')}
      </Text>
      <TextInput
        id={inputId}
        value={name}
        onChange={handleInputChange}
        ref={inputRef}
        placeholder={t('common:recordings.segment-edit-create.name.label')}
        css={getInputCss(inputWidth)}
        isInvalid={name.length === 0 || errorMessage !== null}
      />
      {name.length === 0 && errorMessage !== null ? (
        <Text textType="caption" textColor="text_error">
          {errorMessage}
        </Text>
      ) : null}
    </>
  );
};
